import { render, staticRenderFns } from "./AffiliateCpaForm.vue?vue&type=template&id=47ae4549&scoped=true&"
import script from "./AffiliateCpaForm.vue?vue&type=script&lang=js&"
export * from "./AffiliateCpaForm.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateCpaForm.vue?vue&type=style&index=0&id=47ae4549&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ae4549",
  null
  
)

export default component.exports